import React from 'react';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

const PartnershipShowcase = () => {
  const technologyPartners = [
    {
      category: 'Solutions IA',
      name: 'TechVision AI',
      description: 'Intelligence artificielle pour diagnostic automobile avancé',
      benefits: 'Analyse prédictive, maintenance préventive, optimisation performance',
      icon: 'Brain',
      image: '/assets/images/strategic_intervention_domains_consultation.png',
      alt: 'Partenaire technologique TechVision AI pour solutions d\'intelligence artificielle automobile'
    },
    {
      category: 'Cloud & Infrastructure',
      name: 'CloudServe Pro',
      description: 'Hébergement haute disponibilité et services cloud sécurisés',
      benefits: 'Uptime 99.99%, scalabilité automatique, sécurité renforcée',
      icon: 'Server',
      image: '/assets/images/digital_project_management_hero_background.png',
      alt: 'Infrastructure cloud CloudServe Pro offrant hébergement haute disponibilité pour services CRF Perfection'
    },
    {
      category: 'Logiciels Métier',
      name: 'AutoSoft Solutions',
      description: 'Logiciels de gestion atelier et relation client automobile',
      benefits: 'Intégration ERP, CRM spécialisé, gestion complète atelier',
      icon: 'Settings',
      image: '/assets/images/hr_tech_dashboard_one.png',
      alt: 'Logiciels métier AutoSoft Solutions pour gestion d\'atelier automobile et relation client'
    }
  ];

  return (
    <section className="py-20 lg:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div 
            className="inline-flex items-center px-4 py-2 rounded-full text-sm font-semibold mb-6"
            style={{ backgroundColor: 'rgba(150, 18, 29, 0.1)', color: '#96121D' }}
          >
            <Icon name="Zap" size={16} className="mr-2" />
            Partenaires Technologiques
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Alliances{' '}
            <span style={{ color: '#96121D' }}>Stratégiques</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Des collaborations avec les leaders technologiques qui enrichissent 
            notre offre de services et garantissent l'excellence opérationnelle.
          </p>
        </div>

        {/* Partnership Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {technologyPartners?.map((partner, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group"
            >
              {/* Partner Image */}
              <div className="relative h-48 overflow-hidden">
                <Image
                  src={partner?.image}
                  alt={partner?.alt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                
                {/* Category Badge */}
                <div className="absolute top-4 left-4">
                  <div 
                    className="flex items-center px-3 py-1 rounded-full text-xs font-semibold text-white"
                    style={{ backgroundColor: '#96121D' }}
                  >
                    <Icon name={partner?.icon} size={14} className="mr-1" />
                    {partner?.category}
                  </div>
                </div>
              </div>

              {/* Partner Details */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {partner?.name}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {partner?.description}
                </p>

                {/* Benefits */}
                <div 
                  className="p-4 rounded-lg mb-4"
                  style={{ backgroundColor: 'rgba(155, 142, 87, 0.1)' }}
                >
                  <div className="flex items-start">
                    <Icon 
                      name="CheckCircle" 
                      size={20} 
                      className="mr-2 mt-1 flex-shrink-0"
                      style={{ color: '#9B8E57' }}
                    />
                    <p className="text-sm text-gray-700">
                      {partner?.benefits}
                    </p>
                  </div>
                </div>

                {/* Action Link */}
                <button 
                  className="w-full py-3 rounded-lg font-semibold text-white transition-all duration-300 hover:opacity-90"
                  style={{ backgroundColor: '#96121D' }}
                >
                  <span className="flex items-center justify-center">
                    Découvrir le Partenariat
                    <Icon name="ArrowRight" size={18} className="ml-2" />
                  </span>
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Partnership Value Statement */}
        <div className="mt-16 text-center">
          <div 
            className="inline-block px-8 py-6 rounded-2xl shadow-lg"
            style={{ backgroundColor: '#96121D' }}
          >
            <p className="text-xl font-semibold text-white max-w-4xl">
              "Nos partenariats stratégiques amplifient notre expertise et enrichissent 
              constamment la valeur délivrée à nos clients."
            </p>
            <p className="text-white/80 mt-2">— Direction CRF PERFECTION</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnershipShowcase;